import { SxProps } from "@mui/material";



export const styles_footer: SxProps = {
    width: "100%",
    display: "flex",
    minHeight: "100px",
    marginTop: "3rem",
    borderTop: "1px solid var(--clr-candy-pink)",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexWrap: "wrap",

    "a":
    {
        display: "flex",
        gap: "10px",
        alignItems: "center",
    }
}